import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { NeDescSvg } from './NeDescIcon'

export const NeDescIcon = (props: PropsWithoutRef<IconBaseProps>) => {
  return <Icon component={NeDescSvg} {...props} />
}
